/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonParty,
    JsonPartyFromJSON,
    JsonPartyFromJSONTyped,
    JsonPartyToJSON,
} from './JsonParty';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonParty
 */
export interface ApiResultOfListOfJsonParty {
    /**
     * 
     * @type {Array<JsonParty>}
     * @memberof ApiResultOfListOfJsonParty
     */
    data?: Array<JsonParty>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonParty
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonParty
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonParty
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonParty
     */
    result?: ApiResultOfListOfJsonPartyResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonPartyResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonPartyFromJSON(json: any): ApiResultOfListOfJsonParty {
    return ApiResultOfListOfJsonPartyFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonPartyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonParty {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonPartyFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonPartyToJSON(value?: ApiResultOfListOfJsonParty | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonPartyToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

